import { isCrmHost } from '@/pages/crm/crm-access';
import { createTokenManager } from '@gokrew/ui/auth';
import { Portal, AUTH_REFRESH_URL } from '@gokrew/models/constants';

export const AUTH_PORTAL = isCrmHost ? 'crm' : Portal.Admin;
export const AUTH_SESSION_KEY = `${AUTH_PORTAL}_portal_sessionId`;

export const tokenManager = createTokenManager({
  namespace: AUTH_PORTAL,
  refreshUrl: AUTH_REFRESH_URL,
});
